import {
  SET_SWIMMING_POOL_COMPANIES,
  SET_SWIMMING_POOL_COMPANY,
  SET_INSPECTION_TEMPLATES,
  SET_INSPECTION_TEMPLATE,
  SET_TEMPLATE_ITEMS,
  SET_INSPECTIONS,
  SET_INSPECTION,
  SET_DASHBOARD_STATS,
  ZWEMBADINSPECTIES_ERROR,
  SET_LOADING
} from './actions';

const initialState = {
  swimmingPoolCompanies: [],
  swimmingPoolCompany: null,
  inspectionTemplates: [],
  inspectionTemplate: null,
  templateItems: [],
  inspections: [],
  inspection: null,
  dashboardStats: null,
  loading: false,
  error: null
};

export default function zwembadinspecties(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SWIMMING_POOL_COMPANIES:
      return {
        ...state,
        swimmingPoolCompanies: action.results
      };
    case SET_SWIMMING_POOL_COMPANY:
      return {
        ...state,
        swimmingPoolCompany: action.results
      };
    case SET_INSPECTION_TEMPLATES:
      return {
        ...state,
        inspectionTemplates: action.results
      };
    case SET_INSPECTION_TEMPLATE:
      return {
        ...state,
        inspectionTemplate: action.results
      };
    case SET_TEMPLATE_ITEMS:
      return {
        ...state,
        templateItems: action.results
      };
    case SET_INSPECTIONS:
      return {
        ...state,
        inspections: action.results
      };
    case SET_INSPECTION:
      return {
        ...state,
        inspection: action.results
      };
    case SET_DASHBOARD_STATS:
      return {
        ...state,
        dashboardStats: action.results
      };
    case ZWEMBADINSPECTIES_ERROR:
      return {
        ...state,
        error: action.payload
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.loading
      };
    default:
      return state;
  }
}
